import { Box } from '@mui/material';
import { FluidLayout } from '@/layouts';
import { useFetchCookies, useRouter } from '@/hooks';
import { PageLoader } from '@/components/shared/PageLoader';
import { ReportDetails } from '@/components/Analysis/ReportsRevamped/ReportDetails';
import { EchoChat } from '@/components/shared/EchoChat';

export const ReportsViewPage = () => {
  const router = useRouter();
  const { inspection } = router.query;
  const cookiesFetched = useFetchCookies();

  if (!inspection || Array.isArray(inspection)) {
    return <div>Please specify inspection id</div>;
  }

  if (!cookiesFetched) {
    return (
      <Box sx={{ position: 'relative', top: '25rem' }}>
        <PageLoader />
      </Box>
    );
  }

  return (
    <FluidLayout variant="analysis">
      <ReportDetails />
      <EchoChat />
    </FluidLayout>
  );
};
